import { render, staticRenderFns } from "./info.vue?vue&type=template&id=3b7ebed2&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=3b7ebed2&prod&lang=stylus&scoped=true"
import style1 from "./style.styl?vue&type=style&index=1&id=3b7ebed2&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ebed2",
  null
  
)

export default component.exports